'use strict';

// Note: Commenting based on requirement for RPP-4570
// ReEnable and rewrite based on RPP-3987

 const SELECTORS = {
    phoneField: '.js-phone-field',
}


/**
 * RPP-3987 Formats a phone number as XXX-XXX-XXXXXXXXX (up to 15 digits total)
 */
function formatPhoneNumber(input) {
    if (!input || typeof input !== 'string') return '';

    const cleaned = input.replace(/\D/g, '').substring(0, 15);
    const part1 = cleaned.substring(0, 3);
    const part2 = cleaned.substring(3, 6);
    const part3 = cleaned.substring(6); // rest (0–9 digits)

    if (part2 && part3) {
        return `${part1}-${part2}-${part3}`;
    } else if (part2) {
        return `${part1}-${part2}`;
    } else {
        return part1;
    }
}

/**
 * Initializes real-time phone formatting
 */
function initPhoneFormatting() {
    const $inputs = $(SELECTORS.phoneField);

    // Format phone values on page load
    $inputs.each(function () {
        const formatted = formatPhoneNumber(this.value);
        this.value = formatted;
    });

    // Re-format on input while typing
    $(document).on('input', SELECTORS.phoneField, function () {

        const updatedPhone = $(this).val();
        const $summaryPhoneField = $('#phone');
        if ($summaryPhoneField.length > 0 && !$summaryPhoneField.is(this)) {
            $summaryPhoneField.val(updatedPhone);
        }

        const input = this;
        const cursorPos = input.selectionStart;
        const originalValue = input.value;

        const formatted = formatPhoneNumber(originalValue);
        input.value = formatted;

        // Adjust cursor position
        const adjustment = formatted.length - originalValue.length;
        const newCursorPos = cursorPos + adjustment;
        input.setSelectionRange(newCursorPos, newCursorPos);
    });
}

if ($('.js-phone-field').length > 0) {
    initPhoneFormatting();
}

module.exports = {
    formatPhoneNumber,
    initPhoneFormatting
};